// Path: src\Components\Home\BaseHome.jsx
import React, { useEffect, useRef, useState } from 'react'
import Header from '../Header/Header'
import Footer from './Footer'
import { ToastContainer } from 'react-toastify'
import { useSearchParams } from 'react-router-dom'

const BaseHome = ({isRemoveScroll, children, title, isWallet, isSaveTeam, isFooter, onBackClick, isMore, setStyle, setStyle1, isReward ,notBack, MaxFullPageScroll, isFreeGameIframe}) => {
  const [scrollPosition, setScrollPosition] = useState({ scrollTop: 0, scrollLeft: 0 });
  const [searchParams] = useSearchParams()
  const scrollRef = useRef(null);
  // old logic
  // const handleScroll = () => {
  //   if (scrollRef.current) {
  //     const { scrollTop, scrollLeft } = scrollRef.current;
  //     setScrollPosition({ scrollTop, scrollLeft });
  //     if (scrollPosition.scrollTop > 90 && scrollPosition.scrollTop < 96) {

  //       const translateY = window.innerHeight > 740 ? (window.innerHeight / 40) : 25
  //       setStyle({
  //         transform: 'translate(0, -90%)',
  //         transition: 'all 0.5s ease-out'
  //       })
  //       setStyle1({
  //         transform: `translate(0, -${translateY}%)`,
  //         transition: 'all 0.5s ease-out'
  //       })
  //     }
  //     else if (scrollPosition.scrollTop > 0 && scrollPosition.scrollTop < 10) {
  //       setStyle({
  //         transform: 'translate(0, 0)',
  //         transition: 'all 0.5s ease-out'
  //       })
  //       setStyle1({
  //         transform: 'translate(0, 0)',
  //         transition: 'all 0.5s ease-out'
  //       })
  //     }

  //   }
  // };
  // useEffect(() => {
  //   if (scrollPosition.scrollTop == 90) {

  //     setStyle({
  //       transform: 'translate(0, -80%)'
  //     })
  //   }
    
  // }, [setScrollPosition])


  // new logic
  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop } = scrollRef.current;

      if (scrollTop > 90 && scrollTop < 96) {
        const translateY = window.innerHeight > 740 ? (window.innerHeight / 40) : 25;
        setStyle({
          transform: 'translate(0, -90%)',
          transition: 'all 0.5s ease-out',
        });
        setStyle1({
          transform: `translate(0, -${translateY}%)`,
          transition: 'all 0.5s ease-out',
        });
      } else if (scrollTop > 0 && scrollTop < 10) {
        setStyle({
          transform: 'translate(0, 0)',
          transition: 'all 0.5s ease-out',
        });
        setStyle1({
          transform: 'translate(0, 0)',
          transition: 'all 0.5s ease-out',
        });
      }
    }
  };

  useEffect(() => {
    const currentScrollPosition = scrollRef.current.scrollTop;
    if (currentScrollPosition === 90) {
      setStyle({
        transform: 'translate(0, -80%)',
      });
    }
  }, [scrollRef.current?.scrollTop]); 
  return (
    <>
   
      <ToastContainer />
      <Header title={title} onBackClick={onBackClick} isWallet={isWallet} isReward={isReward} notBack={notBack} />
      <div className={`inner-wrapper ${isWallet || isMore ? "maxHeight" : ""} ${isSaveTeam ? "maxHeightSaveTeam" : ""} ${isFreeGameIframe ? "maxFreeGamePadding" : ""} ${MaxFullPageScroll ? "maxFullPageScroll" : ""} ${isRemoveScroll?'isRemoveScroll':''}`} ref={scrollRef} onScroll={() => {
        // if (setStyle) handleScroll()
      }}>
        {children}
      </div>
      {
        isFooter && <Footer />
      }

    </>
  )
}

export default BaseHome